import { render, staticRenderFns } from "./EditModuleComponent.vue?vue&type=template&id=16dbe122&scoped=true"
import script from "./EditModuleComponent.vue?vue&type=script&lang=js"
export * from "./EditModuleComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16dbe122",
  null
  
)

export default component.exports